module.exports = __webpack_public_path__ + "static/media/gotoiconOffwhite.c2085c87.svg";